export default {
    appLogin({}, payload) {
        const { fullName, token } = payload
        localStorage.setItem('btm_loggedUser', fullName)
        localStorage.setItem('btm_token', token)
    },
    appLogout() {
        localStorage.removeItem('btm_loggedUser')
        localStorage.removeItem('btm_token')
    },
    updateProfile({}, payload) {
        const { fullName } = payload
        localStorage.setItem('btm_loggedUser', fullName)
    },
    appLoading({ commit }, isLoading) {
        commit('setLoading', isLoading);
    }
}